
  <div class="row header align-items-center ">
    <div class="col-sm-12  text-center">
      <h1 id="title-widget" class="title-widget mt-2">
        {{multilingualContent.text.headerCondiciones}}
      </h1>
    </div>
  </div>
